import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/macro';
import { H2 } from '@decisiv/ui-components';
import iconix from '@decisiv/iconix';

import { NoResultDescription, CenteredContainer } from './style';

export default function NoExecutionsFound({ error = null, filtered = false }) {
  if (error) {
    return (
      <CenteredContainer
        flexDirection="column"
        alignItems="center"
        paddingY={2}
      >
        <iconix.ExclamationCircleF height={32} width={32} />
        <H2 marginTop={1} marginBottom={1}>
          <Trans>Executions could not be loaded</Trans>
        </H2>
        <NoResultDescription shade={1}>{error}</NoResultDescription>
      </CenteredContainer>
    );
  }

  return (
    <CenteredContainer flexDirection="column" alignItems="center" paddingY={2}>
      <iconix.Search height={32} width={32} />
      <H2 marginTop={1} marginBottom={1}>
        <Trans>No executions found</Trans>
      </H2>
      <NoResultDescription shade={1}>
        {filtered ? (
          <Trans>
            Try removing or editing some of your filters to expand your search.
          </Trans>
        ) : (
          <Trans>This integration has no executions in the last 30 days.</Trans>
        )}
      </NoResultDescription>
    </CenteredContainer>
  );
}

NoExecutionsFound.propTypes = {
  // The API's error detail; replaces the "no results" copy.
  error: PropTypes.string,
  filtered: PropTypes.bool,
};
